<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger
      class="hamburger-container"
      :toggleClick="toggleSideBar"
      :isActive="sidebar.opened"
    ></hamburger>
    <breadcrumb></breadcrumb>

    <div class="shop-chose" v-if="merchantId >= 1">
      <el-select
        v-model="value"
        :placeholder="$t('merchant.pleaseSelect')"
        @change="choseShop(value)"
      >
        <el-option
          v-for="item in shopList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div class="lang-chose">
      <el-select
        v-model="langValue"
        :placeholder="$t('merchant.pleaseSelect')"
        @change="changeLangEvent"
      >
        <el-option
          v-for="item in langList"
          :key="item.value"
          :label="$t(item.label)"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatar" />
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item> {{ $t("openBrandShop.home") }} </el-dropdown-item>
        </router-link>
        <div @click="logout">
          <el-dropdown-item divided>
            <span @click="logout" style="display: block">
              {{ $t("openBrandShop.quit") }}</span
            >
          </el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { listShop, selectShop } from "@/api/shop";

export default {
  data() {
    return {
      value: null,
      langValue: localStorage.getItem("lang") || "thai",
      shopList: [],
      langList: [
        { label: "中文", value: "zh" },
        { label: "English", value: "en" },
        { label: "ภาษาไทย", value: "thai" },
        // { label: "中文", value: "zh", logoSrc: require("@/assets/zh.png") },
        // { label: "English", value: "en", logoSrc: require("@/assets/en.png") },
        // { label: "ไทย", value: "thai", logoSrc: require("@/assets/thai.png") },
      ],
    };
  },
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters([
      "sidebar",
      "avatar",
      "merchantId",
      "shopId",
      "token",
      "isAddShop",
    ]),
  },
  watch: {
    isAddShop: {
      handler(newval, oldVal) {
        if (newval === "yes") {
          this.getShopList();
          this.$store.commit("SET_ADD_SHOP", "no");
        }
      },
      immediate: true,
    },
  },
  created() {
    if (this.merchantId >= 1) {
      this.getShopList();
    }
  },
  methods: {
    ...mapMutations(["SET_SHOP_ID", "SET_BRAND_LIST", "SET_ADD_SHOP"]),
    changeLangEvent(value) {
      const that = this;
      that.$i18n.locale = value || "thai";
      localStorage.setItem("lang", value);
    },
    getShopList() {
      const param = {
        keyword: "",
        pageNum: 1,
        pageSize: 100,
      };
      listShop(param).then((res) => {
        this.shopList = res.data.list;
        this.$store.commit("SET_BRAND_LIST", this.shopList);
        if (
          sessionStorage.getItem("SHOP_ID") !== "" &&
          sessionStorage.getItem("SHOP_ID") !== null &&
          sessionStorage.getItem("SHOP_ID") !== "0" &&
          sessionStorage.getItem("SHOP_ID") !== 0
        ) {
          this.value = Number(sessionStorage.getItem("SHOP_ID"));
        } else {
          this.value = this.shopList[0].id;
        }
        this.$store.commit("SET_SHOP_ID", this.value);
        if (this.merchantId >= 1) {
          if (sessionStorage.getItem("SHOP_ID") !== "") {
            this.choseShop(Number(this.value));
          } else {
            this.choseShop(this.shopList[0].id);
          }
        }
      });
    },
    openFullScreen() {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        loading.close();
      }, 3000);
    },
    choseShop(id) {
      sessionStorage.setItem("SHOP_ID", id);
      this.$store.commit("SET_SHOP_ID", Number(id));
      if (id !== 0 && id !== "0") {
        selectShop(id).then((res) => {});
      }
      this.openFullScreen();
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
      sessionStorage.setItem("SHOP_ID", "");
      localStorage.setItem("timePocket", "");
      localStorage.setItem("lang", "thai");
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
  .shop-chose {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 300px;
  }
  .lang-chose {
    height: 50px;
    width: 150px;
    display: inline-block;
    position: absolute;
    right: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue